import { DatePicker } from 'antd'

export default function SL_Date(props) {
    return (
        <DatePicker
            {...props}
        />
    )
}